// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"style_wrapper__3cnnY","icon":"style_icon__IDPMn"};